import { render } from "./TheDetail.vue?vue&type=template&id=2d981a9e"
import script from "./TheDetail.vue?vue&type=script&lang=js"
export * from "./TheDetail.vue?vue&type=script&lang=js"

import "./TheDetail.vue?vue&type=style&index=0&id=2d981a9e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/public_html/wp-content/plugins/woo-portal-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__